export const TAB_MAP = {
  'Product Details': {
    id: 'productDetail',
    name: 'Product Details',
    nameKey: 'detail_tab.text_product_detail',
    priority: 0,
    lazyBlockId: 'block-tab-product',
  },
  'Verified Information': {
    id: 'productAuth',
    name: 'Verified Information',
    nameKey: 'detail_tab.text_verified_information',
    priority: 1,
    lazyBlockId: 'block-tab-verified',
  },
  'Company Profile': {
    id: 'companyProfile',
    name: 'Company Profile',
    nameKey: 'detail_tab.text_company_profile',
    priority: 2,
    lazyBlockId: 'block-tab-company',
  },
  'Transactions Overview': {
    id: 'transactionHistory',
    name: 'Transactions',
    nameKey: 'detail_tab.text_transactions_Overview',
    priority: 3,
    lazyBlockId: 'block-tab-transaction-history',
  },
  discuss: {
    id: 'detailDiscuss',
    name: 'Buyer Reviews',
    nameKey: 'detail_tab.discuss',
    priority: 4,
    lazyBlockId: 'block-tab-detail-discuss',
  },
};

export const DETAIL_NAVS = {
  description: 'details_info.text_nav_description',
  packaging: 'details_info.text_nav_packaging',
  services: 'details_info.text_nav_services',
  companyInfo: 'details_info.text_nav_company_info',
  faq: 'details_info.text_nav_faq',
};
